import(/* webpackMode: "eager" */ "/home/runner/work/dreamconnect/dreamconnect/app/error.tsx");
